// extracted by mini-css-extract-plugin
module.exports = {"PageBlog":"PageBlog___3uU_q","allArticles":"allArticles___2isbb","backBlogHome":"backBlogHome___2enQ1","paginationBottom":"paginationBottom___1-K5O"};